import AJAX from './AJAX';
import validateInput from './validateInput';

const ImageUploader = {
  upload(file, viewer, callback) {
    if (!viewer || viewer.loggedOut) {
      callback('Please log in to upload images.');
      return;
    }

    if (!file) {
      callback('no file');
      return;
    }

    if (!validateInput.imageFile(file)) {
      callback('Invalid image file (8MB max, gif/jpg/png/webp)');
      return;
    }

    AJAX.postFile(
      '/api/images/upload',
      {
        imageFile: file,
      },
      {
        imageType: file.type,
      },
      (response) => {
        var responseObject;
        try {
          responseObject = JSON.parse(response);
        } catch (e) {
          responseObject = { error: 'server error' };
        }

        if (responseObject.error || !responseObject.imageURL) {
          callback('server error');
          return;
        }

        callback(null, responseObject.imageURL);
      }
    );
  },
};

export default ImageUploader;
